import { Component, OnInit } from '@angular/core';
import { Theme } from '../service/AutoTheme';

@Component({
  selector: 'app-look',
  templateUrl: './look.component.html',
  styleUrls: ['./look.component.css']
})
export class LookComponent implements OnInit {

  
  color = 'green';
  showSettings = false;
  showMinisidebar = false; 
  showDarktheme = false;
  showHorizontalNav = true;
  showBoxedtheme = false;
  public menu : Boolean;


    constructor(public theme:Theme ) {
      
  } 
  // End open close
  ngOnInit() {

      this.theme.showmenu.subscribe(res=>{
          this.menu= res;
      });
    }
}
